import { render, staticRenderFns } from "./materialItem.vue?vue&type=template&id=7cb77de2&scoped=true"
import script from "./materialItem.vue?vue&type=script&lang=js"
export * from "./materialItem.vue?vue&type=script&lang=js"
import style0 from "./materialItem.vue?vue&type=style&index=0&id=7cb77de2&prod&lang=scss&scoped=true"
import style1 from "./materialItem.vue?vue&type=style&index=1&id=7cb77de2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb77de2",
  null
  
)

export default component.exports